const es = {
  // Common
  back: 'Volver',
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Cerrar',
  loading: 'Cargando...',
  saving: 'Guardando...',
  saved: '¡Guardado!',
  search: 'Buscar',
  edit: 'Editar',
  confirm: 'Confirmar',
  yes: 'Sí',
  no: 'No',
  or: 'o',
  and: 'y',
  none: 'Ninguno',
  unknown: 'Desconocido',
  optional: 'opcional',
  required: 'Requerido',
  noResults: 'No se encontraron resultados',
  signOut: 'Cerrar Sesión',

  // Dashboard
  dashboard: 'Inicio',
  yourFamilyCircles: 'Tus Círculos Familiares',
  selectCircleDesc: 'Selecciona un círculo familiar para grabar y escuchar historias',
  loadingCircles: 'Cargando tus círculos...',
  members: 'miembros',
  createNewCircle: 'Crear Nuevo Círculo',
  startPreserving: 'Comienza a preservar recuerdos con tu familia',
  createFamilyCircle: 'Crear Círculo Familiar',
  circleName: 'Nombre del Círculo',
  circleNamePlaceholder: 'La Familia García',
  descriptionOptional: 'Descripción (opcional)',
  descriptionPlaceholder: 'Nuestros recuerdos e historias familiares',
  creating: 'Creando...',
  createCircle: 'Crear Círculo',
  noDescription: 'Sin descripción',
  hello: 'Hola',
  help: 'Ayuda',
  settings: 'Configuración',

  // Settings
  settingsTitle: 'Configuración',
  profile: 'Perfil',
  displayName: 'Nombre',
  birthday: 'Fecha de Nacimiento',
  birthplace: 'Lugar de Nacimiento',
  birthplacePlaceholder: 'ej., Ciudad de México',
  bio: 'Biografía',
  bioPlaceholder: 'Una breve nota sobre ti...',
  profileSyncNote: 'La fecha de nacimiento, lugar y biografía se sincronizarán automáticamente con tu árbol familiar.',
  saveProfile: 'Guardar Perfil',
  profileSaved: '¡Perfil Guardado!',
  changePhoto: 'Cambiar foto',

  // Language
  language: 'Idioma',
  languageNote: 'El idioma se aplicará a la interfaz de la aplicación.',
  saveLanguage: 'Guardar Idioma',

  // Security
  security: 'Seguridad',
  changePassword: 'Cambiar Contraseña',
  changePasswordDesc: 'Actualiza la contraseña de tu cuenta',
  currentPassword: 'Contraseña Actual',
  currentPasswordPlaceholder: 'Ingresa tu contraseña actual',
  newPassword: 'Nueva Contraseña',
  newPasswordPlaceholder: 'Mínimo 8 caracteres',
  confirmNewPassword: 'Confirmar Nueva Contraseña',
  confirmNewPasswordPlaceholder: 'Vuelve a ingresar tu nueva contraseña',
  changingPassword: 'Cambiando...',
  passwordChanged: '¡Contraseña cambiada exitosamente!',
  passwordsDoNotMatch: 'Las contraseñas no coinciden',
  passwordRuleLength: 'Mínimo 8 caracteres',
  passwordRuleUppercase: 'Una letra mayúscula',
  passwordRuleNumber: 'Un número',
  passwordRuleSpecial: 'Un carácter especial',

  // Notifications
  emailNotifications: 'Notificaciones por Email',
  enableNotifications: 'Activar notificaciones por email',
  enableNotificationsDesc: 'Recibe emails sobre actividad en tus círculos familiares',
  deliveryMethod: 'Método de entrega',
  instant: 'Instantáneo',
  dailyDigest: 'Resumen Diario',
  both: 'Ambos',
  notificationTypes: 'Tipos de notificación',
  newStoryAdded: 'Nueva historia agregada',
  newStoryAddedDesc: 'Cuando alguien graba una nueva historia en tu círculo familiar',
  commentsOnStories: 'Comentarios en tus historias',
  commentsOnStoriesDesc: 'Cuando alguien comenta en una historia que grabaste',
  reactionsToComments: 'Reacciones a tus comentarios',
  reactionsToCommentsDesc: 'Cuando alguien reacciona a un comentario tuyo',
  newMemberJoined: 'Nuevo miembro se unió',
  newMemberJoinedDesc: 'Cuando alguien nuevo se une a tu círculo familiar',
  inviteAccepted: 'Invitación aceptada',
  inviteAcceptedDesc: 'Cuando alguien que invitaste acepta y se une',
  saveChanges: 'Guardar Cambios',

  // Danger Zone
  dangerZone: 'Zona de Peligro',
  deleteAccount: 'Eliminar Cuenta',
  deleteAccountDesc: 'Eliminar permanentemente tu cuenta y todos los datos asociados',
  deleteAccountWarning: 'Esta acción es permanente e irreversible. Todos tus datos, historias y membresías de círculos familiares serán eliminados.',
  enterPassword: 'Ingresa tu contraseña',
  typeDelete: 'Escribe DELETE para confirmar',
  deletingAccount: 'Eliminando...',
  deleteMyAccount: 'Eliminar Mi Cuenta',

  // Email confirmation
  emailNotConfirmed: 'Tu email aún no ha sido confirmado.',
  resend: 'Reenviar',
  sending: 'Enviando...',
  sent: '¡Enviado!',

  // Family Circle
  stories: 'Historias',
  membersTab: 'Miembros',
  tree: 'Árbol',
  recordStory: 'Grabar una Historia',
  exportMemoryBook: 'Exportar Libro de Recuerdos',
  story: 'historia',
  storiesFound: 'encontradas',
  noStoriesMatch: 'Ninguna historia coincide con tu búsqueda',
  clearFilters: 'Limpiar filtros',
  noStoriesYet: 'Aún no hay historias',
  beFirstToRecord: '¡Sé el primero en grabar una historia familiar!',
  filterByStoryteller: 'Filtrar por Narrador',
  allMembers: 'Todos los miembros',
  searchStories: 'Buscar historias...',

  // Story Detail
  originalRecording: 'Grabación Original',
  aiVoiceNarration: 'Narración con Voz IA (pulida)',
  loadAudio: 'Cargar Audio',
  loadingAudio: 'Cargando...',
  generateVoice: 'Generar Narración con Voz',
  cloneVoice: 'Clonar Voz de Esta Grabación',
  linkedStories: 'Historias Vinculadas',
  linkStory: '+ Vincular Historia',
  linkAStory: 'Vincular una Historia',
  connectStoryDesc: 'Conecta esta historia con otra historia relacionada en tu círculo familiar.',
  searchByTitle: 'Buscar por título...',
  relationship: 'Relación',
  noteOptional: 'Nota (opcional)',
  related: 'Relacionado',
  continuation: 'Continuación',
  sameEvent: 'Mismo Evento',
  mentionedIn: 'Mencionado En',
  responseTo: 'Respuesta A',
  parentStory: 'Historia Principal',
  childStory: 'Historia Derivada',
  noLinkedStories: 'Aún no hay historias vinculadas',
  category: 'Categoría',
  uncategorized: 'Sin categoría',
  tags: 'Etiquetas',
  noTagsYet: 'Sin etiquetas aún — clic para agregar',
  addTag: 'Agregar',
  saveTags: 'Guardar Etiquetas',
  comments: 'Comentarios',
  addComment: 'Agregar un comentario...',
  postComment: 'Publicar',
  noComments: '¡Aún no hay comentarios. Sé el primero en compartir tus pensamientos!',
  deleteStory: 'Eliminar Historia',
  deleteStoryConfirm: '¿Estás seguro de que quieres eliminar esta historia? Esto eliminará permanentemente la historia, todas las fotos y grabaciones de audio. Esta acción no se puede deshacer.',
  deletingStory: 'Eliminando...',

  // Export Modal
  exportMemoryBookTitle: 'Exportar Libro de Recuerdos',
  exportDescription: 'Genera un PDF bellamente formateado de las historias de tu familia.',
  storyVersion: 'Versión de la Historia',
  literary: 'Literaria (narrativa completa)',
  polished: 'Pulida (reestructurada)',
  original: 'Original (transcripción)',
  includePhotos: 'Incluir fotos',
  groupByCategory: 'Agrupar historias por categoría (divisores de capítulo)',
  generatePDF: 'Generar PDF',
  allStorytellers: 'Todos los narradores',
  allCategories: 'Todas las categorías',
  filterByCategory: 'Filtrar por Categoría',

  // Family Tree
  familyTree: 'Árbol Familiar',
  visualizeRelationships: 'Visualiza las relaciones de tu familia',
  exportTreePDF: 'Exportar Árbol PDF',
  noTreeMembers: 'Aún no hay miembros familiares para mostrar.',
  addMembersFirst: 'Agrega miembros en la pestaña de Miembros primero.',
  clickToEdit: 'Clic para editar',
  editFamilyMember: 'Editar Miembro Familiar',
  updateInfoFor: 'Actualizar información de',
  relationshipLabel: 'Etiqueta de Relación',
  generation: 'Generación',
  parent: 'Padre/Madre',
  spouse: 'Cónyuge',
  birthDate: 'Fecha de Nacimiento',
  birthPlace: 'Lugar de Nacimiento',
  deathDate: 'Fecha de Fallecimiento',
  deathPlace: 'Lugar de Fallecimiento',
  markDeceased: 'Marcar como fallecido',
  bioOptional: 'Biografía (opcional)',
  bioPlaceholderTree: 'Una breve nota sobre esta persona...',
  saveTreeChanges: 'Guardar Cambios',

  // Categories
  catEarlyLife: 'Primeros Años',
  catChildhood: 'Infancia',
  catSchool: 'Escuela',
  catCollege: 'Universidad',
  catCareer: 'Carrera',
  catMarriage: 'Matrimonio',
  catFamily: 'Familia',
  catParenting: 'Crianza',
  catMilitary: 'Militar',
  catTravel: 'Viajes',
  catImmigration: 'Inmigración',
  catTraditions: 'Tradiciones',
  catHolidays: 'Fiestas',
  catFaith: 'Fe',
  catHealth: 'Salud',
  catHobbies: 'Pasatiempos',
  catFriendship: 'Amistad',
  catLoss: 'Pérdida',
  catAchievement: 'Logro',
  catAdvice: 'Consejo',
  catOther: 'Otro',

  // Generations
  genGrandparents: 'Abuelos y Anteriores',
  genParents: 'Padres',
  genYouSiblings: 'Tú y Hermanos',
  genChildren: 'Hijos',
  genGrandchildren: 'Nietos',

  // Help
  helpCenter: 'Centro de Ayuda',
  helpSubtitle: 'Todo lo que necesitas saber sobre EchoMemoir',
  searchForHelp: 'Buscar ayuda...',
  quickStartGuides: 'Guías de Inicio Rápido',
  faq: 'Preguntas Frecuentes',
  allTopics: 'Todos los Temas',
  searchResults: 'Resultados de Búsqueda',
  stillNeedHelp: '¿Aún Necesitas Ayuda?',
  cantFindAnswer: '¿No encuentras lo que buscas? Contacta a nuestro equipo.',
  emailSupport: 'Enviar Email a Soporte',

  // FamilyCircle - Tabs
  prompts: 'Preguntas',
  record: 'Grabar',

  // FamilyCircle - Stories
  startRecordingFirst: 'Comienza a grabar tu primer recuerdo',
  storyteller: 'Narrador',
  sortBy: 'Ordenar por',
  newestFirst: 'Más recientes',
  oldestFirst: 'Más antiguas',
  chooseCategoryPrompt: 'Elige una categoría para encontrar preguntas inspiradoras',
  storyTitle: 'Título de la Historia',
  storyTitlePlaceholder: 'Mis Recuerdos de Infancia...',
  recordingTip: 'Habla con claridad y tómate tu tiempo. Comparte tu historia de forma natural.',

  // FamilyCircle - Members
  invite: 'Invitar',
  owner: 'Dueño',
  you: 'Tú',
  onlyVaultKeepers: 'Solo los Guardianes pueden gestionar miembros y enviar invitaciones.',
  pendingInvites: 'Invitaciones Pendientes',
  expires: 'Expira',
  cancelInvite: 'Cancelar Invitación',

  // FamilyCircle - Voice
  voiceProfiles: 'Perfiles de Voz',
  noVoiceProfilesYet: 'Aún no hay perfiles de voz',
  createVoiceProfile: 'Crear Perfil de Voz',
  voiceName: 'Nombre de la Voz',
  voiceNamePlaceholder: 'ej., Voz de Papá, Abuela María',
  audioSamples: 'Muestras de Audio',
  creatingVoice: 'Creando...',
  createVoice: 'Crear Voz',

  // FamilyCircle - Tree
  visualizeRelationships: 'Visualiza las relaciones de tu familia',
  noTreeMembers: 'Aún no hay miembros familiares para mostrar.',
  addMembersFirst: 'Agrega miembros en la pestaña de Miembros primero.',

  // Invite Modal
  inviteSent: '¡Invitación Enviada!',
  inviteSentDesc: 'Se ha enviado una invitación a',
  inviteJoinLink: 'Recibirán un email con un enlace para unirse a',
  done: 'Listo',
  inviteFamilyMember: 'Invitar Miembro Familiar',
  sendInviteDesc: 'Envía una invitación para unirse a',
  sendInviteDesc2: 'Recibirán un email con un enlace para unirse.',
  emailAddress: 'Correo Electrónico',
  role: 'Rol',
  contributorRole: 'Colaborador - Puede agregar historias',
  storytellerRole: 'Narrador - Acceso completo',
  viewerRole: 'Observador - Solo puede ver',
  relationshipOptional: 'Parentesco (opcional)',
  relationshipPlaceholder: 'ej., Hija, Tío, Prima',
  sendInvite: 'Enviar Invitación',

  // Change Role Modal
  changeRole: 'Cambiar Rol',
  changeRoleDesc: 'Cambiar el rol de',
  newRole: 'Nuevo Rol',
  vaultKeeperRole: '👑 Guardián - Control total',
  storytellerRoleFull: '📖 Narrador - Puede gestionar historias',
  contributorRoleFull: '✍️ Colaborador - Puede agregar historias',
  viewerRoleFull: '👁️ Observador - Solo puede ver',
  updating: 'Actualizando...',
  updateRole: 'Actualizar Rol',

  // Remove Member Modal
  removeMember: 'Eliminar Miembro',
  removeMemberDesc: '¿Estás seguro de que quieres eliminar a',
  removeMemberDesc2: 'de este círculo familiar? Perderá acceso a todas las historias.',
  removing: 'Eliminando...',

  // Tree Edit Modal
  editFamilyRelationship: 'Editar Relación Familiar',
  updateTreePosition: 'Actualizar posición en el árbol de',
  relationshipLabel: 'Etiqueta de Relación',
  relationshipLabelPlaceholder: 'ej., Padre, Abuela, Tío',
  greatGrandparents: 'Bisabuelos',
  grandparents: 'Abuelos',
  parents: 'Padres',
  youAndSiblings: 'Tú y Hermanos',
  children: 'Hijos',
  grandchildren: 'Nietos',
  greatGrandchildren: 'Bisnietos',

  // Export Modal
  storyVersionLabel: 'Versión de la Historia',
  allStorytellers: 'Todos los narradores',
  generating: 'Generando...',

  // Upgrade Modal
  upgradePlan: 'Mejora Tu Plan',
  upgradeUnlock: 'Mejora para desbloquear:',
  maybeLater: 'Quizás Después',
  viewPlans: 'Ver Planes',
  upgradeNote: 'Planes desde $8/mes. Cancela en cualquier momento.',
  upgradeFeature1: 'Hasta 50 o historias ilimitadas',
  upgradeFeature2: 'Múltiples círculos familiares',
  upgradeFeature3: 'Clonación de voz',
  upgradeFeature4: 'Exportaciones PDF y libros de recuerdos',

  // Pricing Page
  pricingBackToSettings: 'Volver a Configuración',
  pricingWelcome: '¡Bienvenido a tu nuevo plan! Tu suscripción ya está activa.',
  pricingTitle: 'Elige Tu Plan',
  pricingSubtitle: 'Preserva las historias de tu familia para las generaciones futuras',
  pricingMonthly: 'Mensual',
  pricingAnnual: 'Anual',
  pricingSave20: 'Ahorra 20%',
  pricingMostPopular: 'Más Popular',
  pricingCurrentPlan: 'Plan Actual',
  pricingMo: 'mes',
  pricingYear: 'año',
  pricingBilled: 'Facturado',
  pricingManage: 'Administrar Suscripción',
  pricingDowngrade: 'Bajar de Plan',
  pricingGetStarted: 'Comenzar',
  pricingUpgrade: 'Mejorar',
  pricingRedirecting: 'Redirigiendo...',
  pricingCancelsAt: 'Se cancela al final del período:',
  pricingYourUsage: 'Tu Uso',
  pricingFamilyCircles: 'Círculos Familiares',
  pricingQuestions: '¿Preguntas?',
  pricingFaq1Q: '¿Puedo cambiar de plan después?',
  pricingFaq1A: '¡Sí! Mejora o baja de plan en cualquier momento. Los cambios se aplican en tu próximo ciclo de facturación.',
  pricingFaq2Q: '¿Qué pasa si cancelo?',
  pricingFaq2A: 'Mantienes el acceso hasta el final de tu período de facturación, luego tu cuenta vuelve al plan Gratuito. Tus historias nunca se eliminan.',
  pricingFaq3Q: '¿Hay una prueba gratuita?',
  pricingFaq3A: 'El plan Gratuito es tuyo para siempre — no se requiere tarjeta de crédito. Mejora solo cuando estés listo.',

  // Plan names & features
  planFree: 'Gratuito',
  planFreeTagline: 'Comienza a preservar recuerdos',
  planFreeF1: '3 historias',
  planFreeF2: '1 círculo familiar',
  planFreeF3: '5 miembros por círculo',
  planFreeF4: 'Mejora de historias con IA',
  planFreeF5: '100 MB de almacenamiento',
  planFreeLim1: 'Sin clonación de voz',
  planFreeLim2: 'Sin exportaciones PDF',
  planKeeperTagline: 'Para familias en crecimiento',
  planKeeperF1: '50 historias',
  planKeeperF2: '3 círculos familiares',
  planKeeperF3: '20 miembros por círculo',
  planKeeperF4: 'Mejora de historias con IA',
  planKeeperF5: 'Clonación de voz',
  planKeeperF6: 'Exportaciones PDF y libros de recuerdos',
  planKeeperF7: '5 GB de almacenamiento',
  planVaultTagline: 'Legado familiar ilimitado',
  planVaultF1: 'Historias ilimitadas',
  planVaultF2: 'Círculos familiares ilimitados',
  planVaultF3: 'Miembros ilimitados',
  planVaultF4: 'Mejora de historias con IA',
  planVaultF5: 'Clonación de voz',
  planVaultF6: 'Exportaciones PDF y libros de recuerdos',
  planVaultF7: '50 GB de almacenamiento',
  planVaultF8: 'Soporte prioritario',

  // Settings - Subscription
  settingsSubscription: 'Suscripción',
  settingsFreePlan: 'Plan Gratuito',
  settingsUpgradeDesc: 'Mejora para más historias, clonación de voz y exportaciones PDF',
  settingsAnnualBilling: 'Facturación anual',
  settingsMonthlyBilling: 'Facturación mensual',
  settingsManagePlan: 'Administrar Plan',
};

export default es;